<form
  [formGroup]="inviteSignupProcessService.addressForm"
  class="bank-settings-modal">
  <h1 mat-dialog-title>
    {{
      'invite-signup-process-address.component.personal_home_address'
        | localise: 'Personal home address'
    }}
  </h1>

  <div mat-dialog-content>
    <p>
      {{
        'invite-signup-process-address.component.personal_home_address_description'
          | localise: 'Your home address helps us to ensure your identity.'
      }}
    </p>

    <mat-form-field appearance="outline">
      <mat-label>{{
        'invite-signup-process-address.component.home_address'
          | localise: 'Home Address'
      }}</mat-label>
      <input
        matInput
        appDisableAutofill
        formControlName="line1Address"
        #ctrl="ngControl" />
      @if (ctrl.errors?.server; as err) {
        <mat-error>{{ err }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{
        'invite-signup-process-address.component.city' | localise: 'City'
      }}</mat-label>
      <input
        matInput
        name="city"
        appDisableAutofill
        #ctrl="ngControl"
        formControlName="city" />
      @if (ctrl.errors?.server; as err) {
        <mat-error>{{ err }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{
        'invite-signup-process-address.component.state' | localise: 'State'
      }}</mat-label>
      <mat-select
        [panelClass]="themesService.getDarkThemeClass()"
        formControlName="state"
        #ctrl="ngControl">
        @for (item of statesService.usStatesList; track item) {
          <mat-option [value]="item">
            {{ item }}
          </mat-option>
        }
      </mat-select>
      @if (ctrl.errors?.server; as err) {
        <mat-error>{{ err }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{
        'invite-signup-process-address.component.zip' | localise: 'Zip Code'
      }}</mat-label>
      <input
        matInput
        appDisableAutofill
        #ctrl="ngControl"
        mask="00000"
        formControlName="zip" />
      @if (ctrl.errors?.server; as err) {
        <mat-error>{{ err }}</mat-error>
      }
    </mat-form-field>
  </div>

  <div mat-dialog-actions>
    <button
      mat-button
      type="submit"
      class="p-button p-button--rounded p-button--application-next"
      [disabled]="inviteSignupProcessService.addressForm.invalid || loading"
      (click)="next()">
      {{
        'invite-signup-process-address.component.continue'
          | localise: 'Continue'
      }}
    </button>
  </div>

  @if (error) {
    <p class="p-error-message p-error-message--margin">
      {{ error }}
    </p>
  }
</form>
